var render = function render(){var _vm=this,_c=_vm._self._c;return _c('campaigns-table',{attrs:{"headers":_vm.headers,"campaigns":_vm.youtube_campaigns},on:{"filterYoutubeCampaignType":function($event){return _vm.filterYoutubeCampaignType($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }